import {useEffect} from 'react'
import {Outlet} from 'react-router-dom'
import {useThemeMode} from '../../../_myb/partials'

const ErrorsLayout = () => {
  const {mode} = useThemeMode()
  useEffect(() => {
    document.body.style.background =
      mode === 'dark'
        ? 'linear-gradient(135deg, #0B1727 0%, #0B5ED9 50%, #1B84FF 100%)'
        : 'linear-gradient(135deg, #EAF3FF 0%, #CFE4FF 50%, #A9CDFF 100%)'

    return () => {
      document.body.style.background = 'none'
    }
  }, [mode])

  return (
    <div className='d-flex flex-column flex-root'>
      <div className='d-flex flex-column flex-center flex-column-fluid'>
        <div className='d-flex flex-column flex-center text-center p-10'>
          <div className='card card-flush  w-lg-650px py-5'>
            <div className='card-body py-15 py-lg-20'>
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export {ErrorsLayout}
